import { Grid } from '@chakra-ui/react';
import React from 'react';

type KeyMetricsGridProps = {
  children: React.ReactNode;
};

export const KeyMetricsGrid: React.FC<KeyMetricsGridProps> = ({ children }) => {
  const childrenLength = Array.isArray(children) ? children.length : 1;

  return (
    <Grid
      templateColumns={{
        md: `repeat(${Math.ceil(childrenLength / 2)}, 1fr)`,
        xl: `repeat(${childrenLength}, 1fr)`,
      }}
      templateRows={{
        md: `repeat(2, 1fr)`,
        xl: 'none',
      }}
      gap={{ base: '8px', md: '16px', xl: '24px' }}
      w="100%"
      my="30px">
      {children}
    </Grid>
  );
};
